
import React, { Fragment, FunctionComponent, useMemo, } from "react";
import { v4 as uuidv4 } from "uuid";
import ReactTooltip from "react-tooltip";
import { LinkWithoutReload } from "../../core/utils/link-helper";

interface Props {
    value: string
    maxChars: number
    truncation?: "middle" | "right" // default right
    tooltipOptions?: any
    link?: string
}

export const TruncatedWithTooltip: FunctionComponent<Props> = (props: Props) => {

    const { value, maxChars, tooltipOptions, link } = props

    const tid = useMemo(() => (uuidv4()), []);

    const hasTooltip = useMemo(() =>
        value.length > maxChars,
    [value, maxChars]);

    const truncated = useMemo(() => {
        if (maxChars < 4) {
            throw new Error("TruncatedWithTooltip requires maxChars > 3")
        }
        if (value.length < maxChars) {
            return value
        }
        let truncation = props.truncation || "right"
        switch( truncation) {
            case "right":
                return `${value.slice(0, maxChars - 3)}...`
            case "middle": {
                const l = value.length
                const extra = l - maxChars + 3
                const leftCutoff = Math.ceil(l/2 - extra/2)
                const rightCutoff = leftCutoff + extra
                return `${value.slice(0, leftCutoff)}...${value.slice(rightCutoff, l)}`
            }
        }

    }, [maxChars, value, props.truncation]);

    return (
        <Fragment>
        <span data-tip data-for={tid}>
            { link ?
                LinkWithoutReload(link, truncated): truncated
            }
        </span>
        { hasTooltip &&
            <ReactTooltip id={tid} effect="solid" {...tooltipOptions}>
                {value}
            </ReactTooltip>
        }
        </Fragment>
    )
}
